export default {
  state: {
    reservationSearch: '',
    reservationFilters: [],
    selectedFilter: '-1',
    beThereTimeThreshold: 0
  },
  mutations: {
    setReservationSearch (state, value) { state.reservationSearch = value },
    resetReservationSearch (state) { state.reservationSearch = '' },
    setReservationFilters (state, filters) { state.reservationFilters = filters },
    setSelectedFilter (state, value) { state.selectedFilter = value },
    setBeThereTimeThreshold (state, value) { state.beThereTimeThreshold = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/routing/routing-filters.js